import React from 'react';
import { Carousel } from 'react-bootstrap';
import FullimageCard from '../FullImageCard/FullimageCard';
import './FullImageCarousel.css';

const FullImageCarousel = ({ carouselItems }) => {
    return (
        <div className="full-image-carousel-container">
            <Carousel>
                {carouselItems.map((item, index) => (
                    <Carousel.Item key={index} interval={3000}>
                        <FullimageCard
                            imageSrc={item.imageSrc}
                            title={item.title}
                            subtitle={item.subtitle}
                            paragraph={item.paragraph}
                            listItems={item.listItems}
                            model={item.model}
                        />
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
};

export default FullImageCarousel;
